import { Text } from '@cad-arc';
import { useTimeToUpdate } from '../../hooks/use-time-to-update';
import { CommonSize } from '../../../common/helpers/utils';

type LastUpdateTimeProps = {
    timeUpdateKey?: string;
    lastTimestamp?: Date | number;
    delay: number;
    testid?: string;
    size?: CommonSize;
};

/**
 * auto rerender human readable time since `lastTimestamp` every `delay` milliseconds in parentheses
 */
export function LastUpdateTime({
    timeUpdateKey,
    lastTimestamp,
    delay,
    testid = 'LAST_UPDATE_TIME',
    size,
}: LastUpdateTimeProps): React.ReactElement {
    const timeSinceLastTimestamp = useTimeToUpdate(lastTimestamp, delay, timeUpdateKey);

    return (
        <Text fontSize={size} data-testid={testid}>
            ({timeSinceLastTimestamp})
        </Text>
    );
}
